import { PAGE_HOME_URL, PAGE_INCLUSIONE_VOGLIO_SAPERNE_DI_PIU_SERVIZIO, PAGE_HOME_INCLUSIONE, PAGE_CONSULENZA_SOCIALE_GIURIDICA } from 'types/url';

export const BreadcrumbPath = [
  {
    slash: 'Home',
    url: PAGE_HOME_URL,
  },
  {
    slash: 'WeMi inclusione',
    url: PAGE_HOME_INCLUSIONE,
  },
  {
    slash: 'Consulenza sociale e giuridica',
    url: PAGE_CONSULENZA_SOCIALE_GIURIDICA,
  },
  {
    slash: 'VOGLIO SAPERE DI PIÙ SUL SERVIZIO',
    url: PAGE_INCLUSIONE_VOGLIO_SAPERNE_DI_PIU_SERVIZIO,
  },
];

export const title = 'WeMi - Inclusione - Consulenza sociale e giuridica - Voglio sapere di più sul servizio';
export const description = 'Descrizione servizio Voglio sapere di più sul servizio';
export const keywords = 'welfare, milano, servizi, servizio, Consulenza sociale e giuridica Voglio sapere di più sul servizio , servizio Consulenza sociale e giuridica, informazioni Consulenza sociale e giuridica, informazioni Voglio sapere di più sul servizio';
